<template>
    <b-overlay :show="showLoader">
        <b-card>
            <h2 style="font-weight: bold;">Izpolnite podatke o nepremičnini</h2>
            <validation-observer ref="validate">
                <b-form class="form">
                    <RealEstate ref="realEstate" v-model="object" type=""/>
                    <b-form-group class="text-center text-sm-right">
                        <b-button variant="secondary" @click.prevent="validationForm">ODDAJ NEPREMIČNINO</b-button>
                    </b-form-group>
                </b-form>
            </validation-observer>
        </b-card>
    </b-overlay>
</template>

<script>
    import { ValidationObserver } from 'vee-validate'
    import RealEstate from '../../Components/RealEstate'
    import {BButton, BCard, BForm, BFormGroup, BOverlay} from 'bootstrap-vue'
    export default {
        components: {
            ValidationObserver,
            RealEstate,
            BOverlay,
            BCard,
            BForm,
            BFormGroup,
            BButton
        },
        data() {
            return {
                object: {
                    title:'',
                    listing_type:'',
                    author_id:0,
                    date_posted:'',
                    description:'',
                    location:'',
                    size:'',
                    build:'',
                    renovated:'',
                    floor:'',
                    region: '',
                    price:'',
                    price_offer:false,
                    additional_photos:[],
                    main_photo: '',
                    active: true,
                    neighborhood_id: '',
                    provider: ''
                },
                showLoader: false
            }
        },
        methods: {

            validationForm() {
                this.$refs.validate.validate().then(success => {
                    if (success) {
                        this.addRealEstate()
                    }
                })
            },
            async addRealEstate() {
                this.showLoader = true

                try {
                    const isImageUploadSuccessfull = await this.$refs.realEstate.$refs.imageSelector.UploadImagesToAPI()
                    if (!isImageUploadSuccessfull) {
                        this.$printError('Prišlo je do napake pri nalaganju slik')
                        return
                    }
                    if (this.object.main_photo === '') {
                        this.$printWarning('Potrebno je dodati vsaj eno fotografijo')
                        return
                    }

                    this.object.author_id = this.$store.state.user.userData.id
                    this.object.date_posted = new Date()
                    this.parseAllNumericalProperties()

                    await this.$http.put('/api/management/v1/real_estate/', this.object)
                    this.$printSuccess('Nepremičnina je dodana')
                    setTimeout(() => {
                        this.$router.push({name: 'admin-real-estates-list'})
                    }, 1000)
                } catch (error) {
                    this.$printError(error.response.data)
                } finally {
                    this.showLoader = false
                }
            },
            parseAllNumericalProperties() {
                this.object.price = parseFloat(parseFloat(this.object.price).toFixed(2))
                this.object.listing_type = parseFloat(this.object.listing_type)
                this.object.size = parseFloat(parseFloat(this.object.size).toFixed(2))
                this.object.build = parseFloat(this.object.build)
                this.object.renovated = parseFloat(this.object.renovated)
            }
          
        }
    }
</script>